module.exports = __webpack_public_path__ + "static/img/output-thumb_dummy.0db7f51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/output-thumb_dummy.jpg
// module id = MKhb
// module chunks = 1